export const DEFAULT_TILE_SIZE = 32;
export const EMPTY_TILE = 'empty';
